export default __webpack_public_path__ + "static/media/ZIM.a32a32b3.svg";